import axios from 'axios'
import { HTTPS } from '../api/ajax.js'
const LocalStorage = window.localStorage
const sessionStorage = window.sessionStorage
export default {
  methods: {
    // validateCompanyName: (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('公司名称不能为空'))
    //   } else if (!/[\u4e00-\u9fa5]$/.test(value)) {
    //     return callback(new Error('公司名称只能是中文'))
    //   } else {
    //     return true
    //   }
    // },
    // 读取缓存
    getStorage (name) {
      if (!LocalStorage) return false
      let obj = LocalStorage.getItem(name)
      try {
        if (JSON.parse(obj)) {
          obj = JSON.parse(obj)
        }
      } catch (err) {}
      return obj
    },
    // 设置缓存
    setStorage (name, data) {
      if (!LocalStorage) return false
      let obj = data
      if (typeof data === 'object') {
        obj = JSON.stringify(data)
      }
      LocalStorage.setItem(name, obj)
    },
    // 删除缓存
    removeStorage (name) {
      LocalStorage.removeItem(name)
    },

    // 读取Session缓存
    getSessionStorage (name) {
      if (!sessionStorage) return false
      let obj = sessionStorage.getItem(name)
      try {
        if (JSON.parse(obj)) {
          obj = JSON.parse(obj)
        }
      } catch (err) {}
      return obj
    },
    // 设置Session缓存
    setSessionStorage (name, data) {
      if (!sessionStorage) return false
      let obj = data
      if (typeof data === 'object') {
        obj = JSON.stringify(data)
      }
      sessionStorage.setItem(name, obj)
    },
    // 删除Session缓存
    removeSessionStorage (name) {
      sessionStorage.removeItem(name)
    },
    //  验证String必选项
    validateString (rule, value, callback) {
      let timer = null
      if (!value) {
        rule._this.message = true
        callback(new Error(`${rule.message}`))
        timer = setTimeout(function () {
          rule._this.message = false
          timer && clearTimeout(timer)
        }, 1000)
      } else {
        callback()
      }
    },
    // 验证正则
    validateStringReg (rule, value, callback) {
      let timer = null
      if (!value) {
        // 若输入为空时则直接返回
        callback()
        return
      }
      // 转为字符串
      value = typeof value === 'number' ? value + '' : value
      if (!value.match(rule.pattern)) {
        rule._this.message = true
        callback(new Error(`${rule.message}`))
        timer = setTimeout(function () {
          rule._this.message = false
          timer && clearTimeout(timer)
        }, 1000)
      } else {
        callback()
      }
    },
    // 验证选择必选项
    validateSelect (rule, value, callback) {
      let timerSelect = null
      if (!value) {
        rule._this.message = true
        callback(new Error(`${rule.message}`))
        timerSelect = setTimeout(function () {
          rule._this.message = false
          timerSelect && clearTimeout(timerSelect)
        }, 1000)
      } else {
        callback()
      }
    },
    // 上传图片接口
    uploadImgAjax (params) {
      let config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
      return axios.post(
        `${HTTPS}/Register/Ajax/DealerUpload.aspx`,
        params,
        config
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mixins.js